<div class="row d-flex justify-content-center align-items-center"
  *ngIf="isLoading$ | async">
  <div class="col-12 loader-overlay">
    <div class="loader-content">
      <mat-progress-spinner diameter="60" strokeWidth="4" mode="indeterminate" color="primary">
      </mat-progress-spinner>
      <div class="loader-text">Cargando...</div>
    </div>
  </div>
</div>